import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InformesExcel } from '../../models/informes-excel';

@Component({
  selector: 'app-exportar-excel-modal',
  templateUrl: './exportar-excel-modal.component.html',
  styleUrls: ['./exportar-excel-modal.component.css']
})
export class ExportarExcelModalComponent implements OnInit {

  informesExcel: InformesExcel[] = [];
  informesExcelIniciales: InformesExcel[] = [];
  errorSeleccion: boolean = false;
  textoBuscar: string = '';

  constructor(private dialogRef: MatDialogRef<ExportarExcelModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }


  ngOnInit(): void {
    this.informesExcel = this.data.informesExcel;
    this.informesExcelIniciales = [...this.informesExcel];
  }

  esTipoContenido(): boolean {
    return (this.data?.titulo || '').trim().toLowerCase() === 'tipo de contenido a exportar';
  }

  getInformesSeleccionados(): InformesExcel[] {
    return this.informesExcel.filter(informe => informe.seleccionado);
  }

  aceptarExportar(): void {
    const seleccionados = this.getInformesSeleccionados();
    if (!seleccionados.length) {
      this.errorSeleccion = true;
      return;
    }
    this.dialogRef.close(seleccionados);
  }

  buscarItems(textoBuscar: string){
    this.informesExcel = this.informesExcelIniciales.filter(x => x.nombre.toString().toUpperCase().includes(textoBuscar.toString().toUpperCase()));
  }

  isTodosSeleccionados(): boolean {
    return this.informesExcel.length > 0 && this.informesExcel.every(informe => informe.seleccionado);
  }

  toggleSeleccionarTodos(seleccionarTodos: boolean): void {
    this.informesExcel.forEach(informe => {
      informe.seleccionado = seleccionarTodos;
    });
  }

  onInformeSeleccionChange(informe: InformesExcel, seleccionado: boolean): void {
    informe.seleccionado = seleccionado;
  }

}
